import { Grid, Typography, Divider } from "@mui/material";
import React from "react";
import { useTheme } from "@mui/material/styles";
import GoalCategoryGrid from "./GoalCategoryGrid";
import ReviewControls from "../ReviewControls";



const GoalCategoryConfiguration = () => {
  const theme = useTheme();
  const values = [
      { name: "Goal Template", comp: <GoalCategoryGrid /> },
      { name: "Performance review controls", comp: <ReviewControls /> },

  ];

  return (
    <Grid container spacing={2} style={{ padding: "10px 0px 30px 0px" }}>
      {values?.map((value, id) => (
        <React.Fragment key={id}>
          <Grid
            item
            xs={12}
            ml={0.5}
          >
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                paddingLeft: "15px",
                color: theme.palette.primary.contrastText,
              }}
            >
              {value.name}
            </Typography>
            {value?.comp}
          </Grid>
           {([0].includes(id)) && (
                <Grid item xs={12}>
                    <Divider sx={{ my: 1 }} />
                </Grid>
            )}
        </React.Fragment>
      ))}

    </Grid>
  );
};

export default GoalCategoryConfiguration;
